import { ComponentType } from "react";
import { CategoryMenu } from "../types/Types";
import Client from "../components/layout/Admin/Client";
import PackageModule from "../components/tabs/PackageModule";
import OrdersStatus from "../components/tabs/OrdersStatus";
import Staff from "../components/tabs/Staff";
import Chapel from "../components/tabs/Chapel";
import FB from "../components/tabs/FB";
import Reports from "../components/tabs/Reports";
import { ROLES, tabName } from "../constant/constant";
import ClientModule from "../components/tabs/ClientModule";

// Product interface
export interface Product {
  id: number;
  name: string;
  sizes: ProductSize[]; // always an array
  category: string;
  imageUrl: string;
  description: string;
  quantity: number
  status?: string
} 

export interface ProductSize  {
  label: string;   // "8oz", "16oz", or just "Regular"
  price: number;
  stock: number;
  available: boolean;
}


export interface Category {
  id: number;
  categoryName: string;
}

export interface Package {
  id: number;
  packageNo: number;
  packageName: string;
  packageBalance: number;
}

export interface ExtendedClient {
  id?: number
  pin?: number;
  password?: string;
  qrCodeUrl?: string;
  availableBalance?: number;
  packageType?: string;
  deceasedName: string;
  registeredBy: string;
  mobileNo: number;
  email: string;
  address: string;
  scheduleFrom: string;
  scheduleTo: string;
  chapelID: number;
  packageNo: string;
  packageBalance: number;
  additionalBalance?: number;
  status: string;
}

export interface TypesStatusListFilter {
  id: number;
  label: string;
}


export const statusListFilter: TypesStatusListFilter[] = [
  {
    id: 1,
    label: "All"
  },
  {
    id: 2,
    label: "Active"
  },
  {
    id: 3,
    label: "Inactive"
  }
]





export interface TypesCustomer {
  id: number;
  label: string;
}


export const orderListFilter: TypesCustomer[] = [
  {
    id: 0,
    label: "Select Filter"
  },
  {
    id: 1,
    label: "Customer Name"
  },
  {
    id: 4,
    label: "Oder ID"
  },
  {
    id: 2,
    label: "Diseased Name"
  },
  // {
  //   id: 3,
  //   label: "Chapel No."
  // },
  {
    id: 4,
    label: "PIN"
  },
  // {
  //   id: 5,
  //   label: "Date range"
  // },
]


export interface TypesChapel {
  id: number;
  label: string;
}


export const chapels: TypesChapel[] = [
  {
    id: 1,
    label: 'Chapel A'
  },
  {
    id: 2,
    label: 'Chapel B'
  },
  {
    id: 3,
    label: 'Chapel C'
  },
  {
    id: 4,
    label: 'Chapel D'
  },
  {
    id: 5,
    label: 'Chapel E'
  },
]






export interface TypesSortOption {
  id: number;
  label: string;
}


export const sortOptionList: TypesSortOption[] = [
  // {
  //   id: 0,
  //   label: "Sort by"
  // },
  {
    id: 1,
    label: "Name"
  },
  {
    id: 2,
    label: "Pending"
  },
  {
    id: 3,
    label: "Processing"
  },
  {
    id: 4,
    label: "For Pick-Up"
  },
  {
    id: 5,
    label: "Cancelled"
  },
  {
    id: 6,
    label: "Order ID"
  },
]

export interface TypesSortOption {
  id: number;
  label: string;
}


export const sortOptionListPackage: TypesSortOption[] = [
  {
    id: 2,
    label: "Package",
  },
  {
    id: 1,
    label: "Amount",
  },
  {
    id: 3,
    label: "Cup",
  },
]

export const clientStatus: TypesSortOption[] = [
  {
    id: 1,
    label: "All"
  },
  {
    id: 2,
    label: "Active"
  },
  {
    id: 3,
    label: "Inactive"
  },
]





export interface TypeHeaderColumns {
  id: number;
  label: string;
  key: string
}


export interface TypeOrderData {
  orderId: number;
  userName: string;
  totalAmount: number;
  pin: number;
  diseasedName: string;
  status: string
  chapelNo?: string;
}

export interface TypeTabList {
  id: number;
  tabId: number;
  tabName: string;
}

export const tabList: TypeTabList[] = [
  {
    id: 1,
    tabId: 1,
    tabName: "Client"
  },
  {
    id: 2,
    tabId: 2,
    tabName: "Package"
  },
  {
    id: 3,
    tabId: 3,
    tabName: "Order"
  },
]

export const tabListAdmin: TypeTabList[] = [
  {
    id: 1,
    tabId: 1,
    tabName: "Staff"
  },
  { 
    id: 2,
    tabId: 2,
    tabName: "Chapel"
  },
  {
    id: 3,
    tabId: 3,
    tabName: "F&B"
  },
  {
    id: 4,
    tabId: 4,
    tabName: "Client"
  },
  // {
  //   id: 5,
  //   tabId: 5,
  //   tabName: "Package"
  // },
  {
    id: 5,
    tabId: 5,
    tabName: "Reports"
  },

  // {
  //   id: 6,
  //   tabId: 6,
  //   tabName: "Guest"
  // },
]

export interface TypeTabs {
  id: number;
  tabId: number;
  tabName: string;
  allowedRoles: string[];
  component: ComponentType; 
  defaultForRoles?: string[];
}

export const tabsData: TypeTabs[] = [
  {
    id: 1,
    tabId: 1,
    tabName: tabName.CLIENT,
    allowedRoles: [ROLES.CASHIER, ROLES.SUPER_ADMIN , ROLES.DATA_ADMIN, ROLES.ADMINISTRATOR],
    // component: Client,
    component: ClientModule,
    defaultForRoles: [ROLES.CASHIER, ROLES.DATA_ADMIN]
  },
  {
    id: 2,
    tabId: 2,
    tabName: tabName.PACKAGE,
    allowedRoles: [ROLES.CASHIER],
    component: PackageModule
  },
  {
    id: 3,
    tabId: 3,
    tabName: tabName.ORDER,
    allowedRoles: [ROLES.CASHIER],
    component: OrdersStatus
  },

  {
    id: 4,
    tabId: 4,
    tabName: tabName.STAFF,
    allowedRoles: [ROLES.SUPER_ADMIN , ROLES.ADMINISTRATOR, ROLES.ADMIN],
    component: Staff,
    defaultForRoles: [ROLES.ADMINISTRATOR, ROLES.ADMIN, ROLES.SUPER_ADMIN ]
  },
  { 
    id: 5,
    tabId: 5,
    tabName: tabName.CHAPEL,
    allowedRoles: [ROLES.SUPER_ADMIN , ROLES.ADMINISTRATOR, ROLES.DATA_ADMIN, ROLES.ADMIN],
    component: Chapel
  },
  {
    id: 6,
    tabId: 6,
    tabName: tabName.FandB,
    allowedRoles: [ROLES.SUPER_ADMIN , ROLES.ADMINISTRATOR, ROLES.ADMIN],
    component: FB
  },
  {
    id: 7,
    tabId: 7,
    tabName: tabName.REPORTS,
    allowedRoles: [ROLES.SUPER_ADMIN, ROLES.ADMINISTRATOR],
    component: Reports
  },
]

export interface DummyProductPackage {
  productID: number;
  productName: string;
  description: string | null;
  price: number;
  size: string;
  categoryName: string;
  cups: number;
  isAvailable: boolean
}

export const roleTabOrder: Record<string, string[]> = {
  "admin": [tabName.STAFF, tabName.CHAPEL, tabName.FandB],
  "administrator": [tabName.STAFF, tabName.CHAPEL, tabName.FandB],
  "cashier": [tabName.CLIENT, tabName.PACKAGE, tabName.ORDER],
  "super admin": [tabName.STAFF, tabName.CHAPEL, tabName.FandB, tabName.CLIENT, tabName.REPORTS],
  "data admin": [tabName.CLIENT, tabName.CHAPEL],
};